export default "__VITE_ASSET__Cy_d95Tm__"